import { Component, Input, ViewChild, inject } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import type { SelectedFileExtended } from '@common/types/file.type';
import { SpImageEditorComponent } from '@components/sp-image-editor/src/sp-image-editor.component';
import { formattedDateTimeNow } from '@common/helpers';
import { SpImageEditorComponent as SpImageEditorComponent_1 } from '@libs/components/sp-image-editor/src/sp-image-editor.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'web-image-editor-modal',
    templateUrl: './image-editor-modal.component.html',
    styleUrls: ['./image-editor-modal.component.less'],
    imports: [SpImageEditorComponent_1, TranslateModule],
})
export class ImageEditorModalComponent {
    private readonly bsModalRef = inject(BsModalRef);

    @Input() image: SelectedFileExtended;
    @ViewChild(SpImageEditorComponent) imageEditor;

    public onClose: Subject<File> = new Subject<File>();

    onCancel(): void {
        this.bsModalRef.hide();
    }

    async onConfirm() {
        const url = this.imageEditor.editorComponent.editorInstance.toDataURL({ format: 'jpeg', quality: 0.5 });
        const response = await fetch(url);
        const blob = await response.blob();
        const file = new File([blob], `edited_image_${formattedDateTimeNow()}.jpg`, { type: 'image/jpeg' });

        this.onClose.next(file);
        this.bsModalRef.hide();
    }
}
